// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"2754712a","379":"d0b011a1","453":"d1994899","486":"1540afa2","689":"59cbaf34"}[chunkId] + ".chunk.js";
};